import React from "react";
import { Col, Row } from "antd";

export const STYLES = `
  @keyframes calFadeUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  /* ── Header de sección ── */
  .cal-header { margin-bottom: 18px; animation: calFadeUp 0.45s cubic-bezier(0.22,1,0.36,1) both; }
  .cal-eyebrow {
    display: flex; align-items: center; gap: 10px;
    font-size: 10.5px; font-weight: 700; letter-spacing: 0.14em;
    text-transform: uppercase; color: #00BFD6; margin-bottom: 6px;
  }
  .cal-eyebrow-bar {
    display: inline-block; width: 24px; height: 2.5px;
    background: #00BFD6; border-radius: 4px; flex-shrink: 0;
  }
  .cal-title {
    font-size: 22px; font-weight: 700; color: #0f172a;
    margin: 0 0 2px; letter-spacing: -0.02em; line-height: 1.2;
  }
  .cal-subtitle { font-size: 12.5px; color: #94a3b8; font-weight: 500; margin: 0; }
  .cal-sep { height: 1px; background: #f1f5f9; margin-bottom: 18px; }

  /* ── Barra de filtros ── */
  .cal-filtros {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 14px 18px 2px;
    margin-bottom: 16px;
  }

  /* ── Tarjeta KPI ── */
  .cal-kpi {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 14px 16px 12px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04);
    opacity: 0;
    animation: calFadeUp 0.5s cubic-bezier(0.22,1,0.36,1) both;
    transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.2s ease;
    height: 100%;
  }
  .cal-kpi:hover {
    border-color: rgba(0,191,214,0.35);
    box-shadow: 0 4px 24px rgba(0,191,214,0.1), 0 1px 6px rgba(0,0,0,0.06);
    transform: translateY(-2px);
  }
  .cal-kpi-accent {
    height: 3px; width: 32px; border-radius: 3px; margin-bottom: 10px;
  }
  .cal-kpi-label {
    font-size: 9.5px; font-weight: 800; letter-spacing: 0.11em;
    text-transform: uppercase; color: #94a3b8; margin-bottom: 4px;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .cal-kpi-value {
    font-size: 24px; font-weight: 700; letter-spacing: -0.02em; line-height: 1.1;
  }
  .cal-kpi-hint { font-size: 10.5px; color: #94a3b8; font-weight: 500; margin-top: 2px; }

  /* ── Card de gráfica ── */
  .cal-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px 20px 14px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04);
    opacity: 0;
    animation: calFadeUp 0.55s cubic-bezier(0.22,1,0.36,1) both;
    transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.2s ease;
    height: 100%;
  }
  .cal-card:hover {
    border-color: rgba(0,191,214,0.35);
    box-shadow: 0 4px 24px rgba(0,191,214,0.1), 0 1px 6px rgba(0,0,0,0.06);
    transform: translateY(-2px);
  }
  .cal-card-accent {
    height: 3px; width: 40px; border-radius: 3px; margin-bottom: 14px;
    background: linear-gradient(90deg, #00BFD6, #22d3ee);
  }
  .cal-card-label {
    font-size: 9.5px; font-weight: 800; letter-spacing: 0.13em;
    text-transform: uppercase; color: #00BFD6; margin-bottom: 2px;
  }
  .cal-card-title {
    font-size: 15px; font-weight: 700; color: #1e293b; margin: 0; letter-spacing: -0.01em;
  }
  .cal-card-head {
    display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px;
  }
  .cal-pill {
    display: inline-flex; align-items: center; gap: 5px;
    background: #f0fdff; border: 1px solid #a5f3fc; color: #0891b2;
    font-size: 10px; font-weight: 700; letter-spacing: 0.05em;
    padding: 3px 10px; border-radius: 20px; white-space: nowrap; flex-shrink: 0;
  }
  .cal-pill-dot { width: 5px; height: 5px; border-radius: 50%; background: #00BFD6; flex-shrink: 0; }

  /* ── Ficha de datos (programa / colaborador) ── */
  .cal-ficha {
    background: linear-gradient(135deg, #f0fdff 0%, #ffffff 60%);
    border: 1px solid #a5f3fc;
    border-radius: 16px;
    padding: 16px 20px;
    margin-bottom: 16px;
    animation: calFadeUp 0.45s cubic-bezier(0.22,1,0.36,1) both;
  }
  .cal-ficha-nombre {
    font-size: 18px; font-weight: 700; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 10px;
  }
  .cal-ficha-dato { font-size: 12px; color: #64748b; }
  .cal-ficha-dato b { color: #1e293b; font-weight: 600; }

  /* ── Estado vacío ── */
  .cal-vacio {
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 16px;
    padding: 44px 24px;
    text-align: center;
  }
  .cal-vacio-titulo { font-size: 15px; font-weight: 700; color: #1e293b; margin-bottom: 4px; }
  .cal-vacio-texto { font-size: 12.5px; color: #94a3b8; }

  /* ── Subtítulo dentro de una fila expandida ── */
  .cal-sub-titulo {
    font-size: 11px; font-weight: 800; letter-spacing: 0.08em;
    text-transform: uppercase; color: #94a3b8; margin-bottom: 8px;
  }

  /* ── Rejilla de criterios de la fila expandida ──
     Se usa CSS grid en vez de un <Table> anidado: antd colapsa las tablas anidadas
     dentro de expandedRowRender cuando la tabla padre tiene scroll horizontal. */
  .cal-grid-criterios {
    display: grid;
    grid-template-columns: minmax(220px, 2.2fr) 68px 74px 86px 108px minmax(160px, 1.6fr);
    gap: 0;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
    background: #ffffff;
    min-width: 720px;
  }
  .cal-grid-head {
    background: #f8fafc;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #64748b;
    padding: 7px 10px;
    border-bottom: 1px solid #e2e8f0;
  }
  .cal-grid-cell {
    font-size: 12.5px;
    color: #1e293b;
    padding: 7px 10px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    word-break: break-word;
  }
  .cal-grid-criterios > .cal-grid-cell:nth-last-child(-n+6) { border-bottom: none; }
  .cal-grid-criterios .cal-c { justify-content: center; text-align: center; }

  .cal-spin .ant-spin-dot-item { background: #00BFD6 !important; }

  @media (max-width: 767px) {
    .cal-title { font-size: 18px; }
    .cal-card { padding: 14px 14px 10px; border-radius: 14px; }
    .cal-kpi-value { font-size: 20px; }
    .cal-filtros { padding: 12px 12px 0; border-radius: 12px; }
  }
`;

export const NIVO_THEME = {
  background: "transparent",
  text: { fill: "#94a3b8", fontSize: 10.5, fontFamily: "'Plus Jakarta Sans', sans-serif" },
  grid: { line: { stroke: "#f1f5f9", strokeWidth: 1 } },
  axis: { ticks: { text: { fill: "#94a3b8", fontSize: 10 } } },
  tooltip: {
    container: {
      background: "#ffffff",
      color: "#1e293b",
      border: "1px solid #e2e8f0",
      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
      borderRadius: 10,
      fontSize: 12,
    },
  },
};

export const COLOR_RESULTADO = {
  completado: "#10b981",
  completado_con_observaciones: "#f59e0b",
  rechazado: "#ef4444",
  pendiente: "#94a3b8",
};

export const COLORES_RESULTADO = ["#10b981", "#f59e0b", "#ef4444", "#94a3b8"];

export const PALETA = [
  "#00BFD6", "#6366f1", "#0ea5e9", "#a78bfa",
  "#34d399", "#f59e0b", "#f97316", "#ec4899",
  "#10b981", "#8b5cf6",
];

export const RESULTADO_LABEL = {
  completado: "Completado",
  completado_con_observaciones: "Con observaciones",
  rechazado: "Rechazado",
  pendiente: "Pendiente",
  cancelado: "Cancelado",
};

export const RESULTADO_TAG = {
  completado: "green",
  completado_con_observaciones: "orange",
  rechazado: "red",
  pendiente: "default",
  cancelado: "default",
};

/** Color de severidad por porcentaje de cumplimiento. */
export const colorPorcentaje = (p) =>
  p >= 90 ? "#10b981" : p >= 70 ? "#f59e0b" : "#ef4444";

export const tagPorcentaje = (p) => (p >= 90 ? "green" : p >= 70 ? "orange" : "red");

export const fmtDiaCorto = (clave) => {
  const [, mes, dia] = String(clave).split("-");
  return dia && mes ? `${dia}/${mes}` : clave;
};

export const ordenarPorClave = ([a], [b]) => (a < b ? -1 : a > b ? 1 : 0);

export const isMobile = () => window.innerWidth < 768;


export const HeaderReporte = ({ eyebrow, titulo, subtitulo }) => (
  <div className="cal-header">
    <div className="cal-eyebrow">
      <span className="cal-eyebrow-bar" />
      {eyebrow}
    </div>
    <h1 className="cal-title">{titulo}</h1>
    {subtitulo && <p className="cal-subtitle">{subtitulo}</p>}
  </div>
);

export const Pill = ({ children }) => (
  <span className="cal-pill">
    <span className="cal-pill-dot" />
    {children}
  </span>
);

/**
 * Fila de tarjetas KPI.
 */
export const KpiRow = ({ items = [], style }) => {
  const visibles = items.filter(Boolean);
  if (visibles.length === 0) return null;
  const span = Math.max(4, Math.floor(24 / Math.min(visibles.length, 6)));

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 16, ...style }}>
      {visibles.map((item, i) => (
        <Col key={item.key} xs={12} sm={8} md={item.span ?? span}>
          <div className="cal-kpi" style={{ animationDelay: `${0.04 * i}s` }}>
            <div className="cal-kpi-accent" style={{ background: item.color }} />
            <div className="cal-kpi-label" title={item.label}>{item.label}</div>
            <div className="cal-kpi-value" style={{ color: item.color }}>{item.value}</div>
            {item.hint && <div className="cal-kpi-hint">{item.hint}</div>}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export const ChartCard = ({ label, titulo, pill, accent, altura = 250, delay = 0, children }) => (
  <div className="cal-card" style={{ animationDelay: `${delay}s` }}>
    <div className="cal-card-head">
      <div>
        <div className="cal-card-label">{label}</div>
        <h2 className="cal-card-title">{titulo}</h2>
      </div>
      {pill && <Pill>{pill}</Pill>}
    </div>
    <div
      className="cal-card-accent"
      style={accent ? { background: accent } : undefined}
    />
    <div style={{ height: altura }}>{children}</div>
  </div>
);

export const EstadoVacio = ({ titulo, texto }) => (
  <div className="cal-vacio">
    <div className="cal-vacio-titulo">{titulo}</div>
    <div className="cal-vacio-texto">{texto}</div>
  </div>
);

export const TooltipCalidad = ({ color, titulo, filas = [] }) => (
  <div
    style={{
      padding: "10px 14px",
      background: "#fff",
      border: "1px solid #e2e8f0",
      borderRadius: 10,
      boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
      fontSize: 12,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      minWidth: 160,
      maxWidth: 300,
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
      <span style={{ width: 8, height: 8, borderRadius: 999, background: color, flexShrink: 0 }} />
      <span style={{ fontWeight: 700, color: "#1e293b", fontSize: 12 }}>{titulo}</span>
    </div>
    {filas.map((f) => (
      <div
        key={f.label}
        style={{ display: "flex", justifyContent: "space-between", gap: 14, marginBottom: 2 }}
      >
        <span style={{ color: "#94a3b8", fontSize: 11 }}>{f.label}</span>
        <span style={{ color: "#00BFD6", fontWeight: 700, fontSize: 12 }}>{f.value}</span>
      </div>
    ))}
  </div>
);
